<template>
  <div class="product-details--header">
    <div class="mb-40">
      <h4 class="flex justify-between" @click="$emit('close')">
        <router-link
          class="opacity-04-hover no-margin"
          :to="'/brands/' + brandUrl"
          data-test-id="product-description_link_brand"
        >
          {{ brandName }}
        </router-link>
        <span class="block color-gray">${{ brandMinimumOrderValue }} minimum</span>
      </h4>
    </div>

    <h1 class="font-size-36 mb-15 no-transform break-word">{{ productName }}</h1>

    <div class="flex">
      <h4 class="font-size-12-sm" v-if="userLoggedIn">
        <span v-if="userLoggedIn">
          <span>$</span>
          <span v-if="!variant">
            {{ productWholeSalePrice && productWholeSalePrice.toFixed(2) }}
          </span>
          <span v-else>
            {{ variant.price && variant.price.toFixed(2) }}
          </span>
          <span>Wholesale</span>
        </span>
      </h4>

      <span class="font-weight-bold mx-5" v-if="userLoggedIn">/</span>

      <h4 class="font-size-12-sm">
        <span>
          <span v-if="!variant">${{ productPosPrice && productPosPrice.toFixed(2) }} Retail </span>
          <span v-else-if="variant.pos_price">${{ variant.pos_price.toFixed(2) }} Retail </span>
          <span v-else>&nbsp;</span>
        </span>
      </h4>

      <favorite
        :tracking-info="trackingInfo"
        class="inline-block ml-10"
        v-if="favoriteData"
        :is-fav="favoriteData.is_fav"
        :id="favoriteData.id"
        :is-product="true"
        :is-button="false"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-details--header {
  .product--name {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.1px;
    color: #000000;
  }
}
</style>
<script>
export default {
  props: [
    "brandName",
    "brandUrl",
    "brandMinimumOrderValue",
    "productName",
    "variant",
    "productWholeSalePrice",
    "favoriteData",
    "userLoggedIn",
    "productPosPrice",
    "categoryName",
  ],

  data() {
    return {
      trackingInfo: {
        "Product name": this.productName,
        "Brand name": this.brandName,
        Category: this.categoryName,
      },
    };
  },
};
</script>
